import React, { useState, useEffect } from "react";
import axios from "axios";
import Footer from "./Footer";
import NavbarComponent from "./NavbarComponent";
import { useParams } from "react-router-dom";
import API_URLS from './apiConfig';
import ValuesComponent from "./ValuesComponent";

// Reusable Section Component
const Section = ({ id, title, description, image, link, isActive, btnname }) => (
  <div id={`section-${id}`} className="section" data-id={id}>
    <div className="content slide-right">
      <h1 className="section-common-title">{title}</h1>
      <div dangerouslySetInnerHTML={{ __html: description }} />
      {btnname!=='' ? 
        <a className="viewmore-btn" href={link}>
          {btnname}
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 48 48" fill="none">
            <path d="M16 32L32 16M32 16H20M32 16V28" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
        : null
      }
    </div>
    <div className="image-section">
      <div className="image-container">
        <img src={image} alt={title} className="slide-left" />
      </div>
    </div>
  </div>
);

const ArtificialIntelligence = () => {
  const [sections, setSections] = useState([]);
  const [category, setCategory] = useState([]);
  const [activeSection, setActiveSection] = useState(1);
  const [scrollDirection, setScrollDirection] = useState("up");

  const imageUrl = API_URLS.baseUrl;
  const { id } = useParams();
  const { pagename } = useParams();
  const defaultlang = API_URLS.defaultLang;
  const homeUrl=API_URLS.baseFrontUrl;

  useEffect(() => {
      axios
      .get(API_URLS.getAllDetails+`/${pagename}/${id}/${defaultlang}`)
      .then((response) => {
        // console.log(response.data);
        const transformedSections = response.data.posts.map((post, index) => ({
          id: index + 1,
          title: post.title,
          description: post.content,
          image: post.featured_image ? `${imageUrl}${post.featured_image}` : "/images/default-image.jpg",
          link: homeUrl+'/0/details/'+post.view_url,
          btnname: post.excerpt,
          secvalues: Array.isArray(post.values) && post.values.length!==0?post.values:'',
        }));
        console.log(transformedSections);
        setSections(transformedSections);
        setCategory(response.data.category);
      })
      .catch((error) => {
        console.error("Error fetching menu data:", error);
      });
  }, [pagename, id, defaultlang]);

  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1); // Remove the '#' from the hash
      const sectionElement = document.getElementById(hash);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
        setActiveSection(parseInt(hash.split('-')[1], 10)); // Extract section id
      }
    }
  }, [sections]); // Run after sections are set

  useEffect(() => {
    let lastScrollTop = window.scrollY;

    const handleScroll = () => {
      const currentScroll = window.scrollY;
      setScrollDirection(currentScroll > lastScrollTop ? "down" : "up");
      lastScrollTop = Math.max(currentScroll, 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const observerOptions = { root: null, rootMargin: "0px", threshold: 0.5 };
    const sectionElements = sections.map((section,index) => document.getElementById(`section-${section.id}`));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActiveSection(parseInt(entry.target.dataset.id, 10));
      });
    }, observerOptions);

    sectionElements.forEach((section) => section && observer.observe(section));

    return () => sectionElements.forEach((section) => section && observer.unobserve(section));
  }, [sections]);

  const handleScrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(`section-${sectionId}`);
    if (sectionElement) sectionElement.scrollIntoView({ behavior: "smooth" });
    setActiveSection(sectionId);
    console.log(sectionId);
  };

  return (
    <div>
      <NavbarComponent />
      <header
        className="inner-pages-universal-header"
        style={{
          top: scrollDirection === "down" ? "0px" : "75px",
          transition: "top 0.3s ease",
        }}
      >
        <div className="container">{category}</div>
      </header>
      <div className="main-content">
        <div className="main-content-bg">
          <aside className="sidebar">
            <div className="tags">
              {sections.map((section,index) => (
                <span key={index} style={{ display: activeSection === section.id ? "block" : "none" }}>
                  {section.title}
                </span>
              ))}
            </div>
            {sections.map((section, index) => (
              <div key={index} className="icon-container">
                <div
                  className={`icon ${activeSection >= section.id ? "active" : ""}`}
                  onClick={() => handleScrollToSection(section.id)}
                />
                {index < sections.length - 1 && (
                  <div className={`line ${activeSection > section.id ? "active" : ""}`} />
                )}
              </div>
            ))}
          </aside>
          <main className="container">
            {sections.map((section,index) => (
              <>
                {
                  section.secvalues !== '' ?
                    <ValuesComponent id={section.id} title={section.title} secvalues={section.secvalues} />
                  : <Section
                      key={index}
                      id={section.id}
                      title={section.title}
                      description={section.description}
                      image={section.image}
                      link={section.link}
                      btnname={section.btnname}
                      isActive={activeSection === section.id}
                    />
                }
              </>
            ))}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ArtificialIntelligence;
